<template>
  <div>
    <v-list style="padding:0px" dense>
      <v-list-tile @click="$router.push('/')" :class="[way=='home'?'primary':'']">
        <v-list-tile-action>
          <v-icon :class="[way=='home'?'whitecolor':'']" :style="{fontSize:fontsize}">home</v-icon>
        </v-list-tile-action>
        <v-list-tile-content>
          <v-list-tile-title :class="[way=='home'?'whitecolor':'']">Home</v-list-tile-title>
        </v-list-tile-content>
      </v-list-tile>
      <v-divider></v-divider>
      <div class="text-xs-center" v-if="fontsize=='2.5em'">
        <v-menu v-model="menu" :close-on-content-click="true" :nudge-width="200" offset-x right>
          <v-btn icon slot="activator">
            <v-icon color="#808080" :style="{fontSize:'2.3em'}">receipt</v-icon>
          </v-btn>
          <v-card>
            <v-list dense>
              <template v-for="(item, i) in list">
                <v-list-tile
                  v-if="item.enable"
                  @click="$router.push('/'+item.path)"
                  :key="'listItem-'+i"
                >
                  <v-list-tile-action>
                    <v-icon :style="{fontSize:'1.5em'}">trending_flat</v-icon>
                  </v-list-tile-action>
                  <v-list-tile-content>
                    <v-list-tile-title>{{item.name}}</v-list-tile-title>
                  </v-list-tile-content>
                </v-list-tile>
                <v-divider v-if="item.enable" :key="'listItem-border'+i"></v-divider>
              </template>
            </v-list>
          </v-card>
        </v-menu>
      </div>
      <v-list-group v-else>
        <v-list-tile slot="activator">
          <v-list-tile-action>
            <v-icon :style="{fontSize:fontsize}">receipt</v-icon>
          </v-list-tile-action>
          <v-list-tile-content>
            <v-list-tile-title>Recharge Detail</v-list-tile-title>
          </v-list-tile-content>
        </v-list-tile>
        <v-divider></v-divider>
        <template v-for="(item, i) in list">
          <v-list-tile
            v-if="item.enable"
            @click="$router.push('/'+item.path)"
            :class="[way === item.path?'primary':'']"
            :key="'listItem-'+i"
          >
            <v-list-tile-action>
              <v-icon
                :style="{fontSize:fontsize}"
                :class="[way === item.path?'whitecolor':'']"
              >trending_flat</v-icon>
            </v-list-tile-action>
            <v-list-tile-content>
              <v-list-tile-title :class="[way === item.path?'whitecolor':'']">{{item.name}}</v-list-tile-title>
            </v-list-tile-content>
          </v-list-tile>
          <v-divider v-if="item.enable" :key="'listBorder-'+i"></v-divider>
        </template>
      </v-list-group>
      <v-divider></v-divider>
      <template v-if="this.minkspayenable && this.isPay2">
      <v-list-tile @click="$router.push('/minkspay')" :class="[way=='minkspay'?'primary':'']" >
        <v-list-tile-action>
          <v-icon :style="{fontSize:fontsize}" :class="[way=='minkspay'?'whitecolor':'']">account_balance_wallet</v-icon>
        </v-list-tile-action>
        <v-list-tile-content>
          <v-list-tile-title :class="[way=='minkspay'?'whitecolor':'']">DMR</v-list-tile-title>
        </v-list-tile-content>
      </v-list-tile>
      <v-divider></v-divider>
      </template>

      <v-list-tile @click="$router.push('/offers')" :class="[way=='offers'?'primary':'']">
        <v-list-tile-action>
          <v-icon :style="{fontSize:fontsize}" :class="[way=='offers'?'whitecolor':'']">local_offer</v-icon>
        </v-list-tile-action>
        <v-list-tile-content>
          <v-list-tile-title :class="[way=='offers'?'whitecolor':'']">Check Offers</v-list-tile-title>
        </v-list-tile-content>
      </v-list-tile>
      <v-divider></v-divider>
      <v-list-tile @click="$router.push('/settings')" :class="[way=='settings'?'primary':'']">
        <v-list-tile-action>
          <v-icon :style="{fontSize:fontsize}" :class="[way=='settings'?'whitecolor':'']">settings</v-icon>
        </v-list-tile-action>
        <v-list-tile-content>
          <v-list-tile-title :class="[way=='settings'?'whitecolor':'']">Settings</v-list-tile-title>
        </v-list-tile-content>
      </v-list-tile>
      <v-divider></v-divider>
      <v-list-tile
        v-if="shoppingenabled"
        @click="$router.push('/shopping')"
        :class="[way=='shopping'?'primary':'']"
      >
        <v-list-tile-action>
          <v-icon
            :style="{fontSize:fontsize}"
            :class="[way=='shopping'?'whitecolor':'']"
          >shopping_cart</v-icon>
        </v-list-tile-action>
        <v-list-tile-content>
          <v-list-tile-title :class="[way=='shopping'?'whitecolor':'']">Shopping</v-list-tile-title>
        </v-list-tile-content>
      </v-list-tile>
      <v-divider v-if="shoppingenabled"></v-divider>
      <v-list-tile @click="$router.push('/qrcode')" :class="[way=='qrcode'?'primary':'']">
        <v-list-tile-action>
          <div v-if="fontsize=='2.5em'">
            <img
              :src="require('../assets/qr-codew.svg')"
              style="padding-top:5px;margin-left:5px"
              v-if="way=='qrcode'"
              :width="25"
            />
            <img
              :src="require('../assets/qr-code.svg')"
              v-else
              :width="25"
              style="padding-top:5px;margin-left:5px"
            />
          </div>
          <div v-else>
            <img :src="require('../assets/qr-codew.svg')" v-if="way=='qrcode'" :width="20" />
            <img :src="require('../assets/qr-code.svg')" v-else :width="20" />
          </div>
        </v-list-tile-action>
        <v-list-tile-content>
          <v-list-tile-title :class="[way=='qrcode'?'whitecolor':'']">Generate QR Code</v-list-tile-title>
        </v-list-tile-content>
      </v-list-tile>
      <v-divider></v-divider>
      <v-list-tile @click="$router.push('/getqrcode')" v-if="enableGetQR" :class="[way=='getqrcode'?'primary':'']">
        <v-list-tile-action>
          <div v-if="fontsize=='2.5em'">
            <img
              :src="require('../assets/qr-codew.svg')"
              style="padding-top:5px;margin-left:5px"
              v-if="way=='getqrcode'"
              :width="25"
            />
            <img
              :src="require('../assets/qr-code.svg')"
              v-else
              :width="25"
              style="padding-top:5px;margin-left:5px"
            />
          </div>
          <div v-else>
            <img :src="require('../assets/qr-codew.svg')" v-if="way=='getqrcode'" :width="20" />
            <img :src="require('../assets/qr-code.svg')" v-else :width="20" />
          </div>
        </v-list-tile-action>
        <v-list-tile-content>
          <v-list-tile-title :class="[way=='getqrcode'?'whitecolor':'']">Get QR Code</v-list-tile-title>
        </v-list-tile-content>
      </v-list-tile>
      <v-divider></v-divider>
      <!--
        <v-list-tile @click="openb2c" :class="[way==''?'primary':'']">
          <v-list-tile-action>
              <img :src="require('../assets/playstore.svg')" v-if="fontsize=='2.5em'" :width="30"/>
              <img :src="require('../assets/playstore.svg')" v-else :width="20"/>
          </v-list-tile-action>
          <v-list-tile-content >
            <v-list-tile-title  :class="[way==''?'whitecolor':'']">B2C APP</v-list-tile-title>
          </v-list-tile-content>
        </v-list-tile>
         <v-divider></v-divider>

        <v-list-tile @click="opend2r" :class="[way==''?'primary':'']">
          <v-list-tile-action>
              <img :src="require('../assets/playstore.svg')" v-if="fontsize=='2.5em'" :width="30"/>
              <img :src="require('../assets/playstore.svg')" v-else :width="20"/>
          </v-list-tile-action>
          <v-list-tile-content>
            <v-list-tile-title  :class="[way==''?'whitecolor':'']">D2R APP</v-list-tile-title>
          </v-list-tile-content>
        </v-list-tile>
         <v-divider></v-divider>
      -->
    </v-list>
    <v-list two-line style="padding:0px;margin:0px;">
      <v-list-tile :class="[way==''?'primary':'']">
        <v-list-tile-action>
          <v-icon color="indigo" :class="[way==''?'whitecolor':'']">phone</v-icon>
        </v-list-tile-action>
        <v-list-tile-content>
          <v-list-tile-title>{{support}}</v-list-tile-title>
          <v-list-tile-sub-title>For Support</v-list-tile-sub-title>
        </v-list-tile-content>
      </v-list-tile>
      <v-divider></v-divider>
    </v-list>
  </div>
</template>

<script>
export default {
  props: ["fsize"],
  data() {
    return {
      way: "home",
      fontsize: "1.8em",
      menu: false,
      support: ""
    };
  },
  computed: {
    enableGetQR() {
      return this.$store.getters.enableGetQR;
    },
    aepsenable() {
      return this.$store.getters.aepsenable;
    },
    dmrenable() {
      return this.$store.getters.dmrenable;
    },
    ezpayenable() {
      return this.$store.getters.ezpayenable;
    },
    instapayenable() {
      return this.$store.getters.instapayenable;
    },
    shoppingenabled() {
      return this.$store.getters.shoppingenable;
    },
    instantpayoutenable() {
      return this.$store.getters.instantpayoutenable;
    },
    aepspayout() {
      return this.$store.getters.aepspayout;
    },
    minkspayenable() {
      return this.$store.getters.minkspayenable;
    },
    isPay2() {
      return this.$store.getters.isPay2;
    },

    list() {
      return [
        {
          name: "DMR - Money Transfer",
          path: "dmrtransfer",
          enable: this.dmrenable
        },
        {
          name: "EZPAY - Money Transfer",
          path: "ezpay",
          enable: this.ezpayenable
        },
        {
          name: "DMR",
          path: "instapay",
          enable: this.instapayenable
        },
        {
          name: "MinksPay DMR",
          path: "minkspay",
          enable: this.minkspayenable && !this.isPay2
        },
        {
          name: "Instant AEPS - Money Transfer",
          path: "aeps",
          enable: this.aepsenable
        },
        {
          name: "Instant Payout",
          path: "instantPayout",
          enable: this.instantpayoutenable
        },
        {
          name: "AEPS Payout",
          path: "aepsPayout",
          enable: this.aepspayout
        },
        
        {
          name: "Last 50 Recharge",
          path: "last50recharge",
          enable: true
        },
        {
          name: "Search Recharge",
          path: "searchrecharge",
          enable: true
        },
        {
          name: "Passbook(TopUp)",
          path: "passbook",
          enable: true
        },
        {
          name: "Passbook(Statement)",
          path: "passbookstatement",
          enable: true
        },
        {
          name: "Passbook(Withdrawal)",
          path: "passbookwithdrawal",
          enable: true
        },
        {
          name: "Peer To Peer Statement",
          path: "peertopeerstatement",
          enable: true
        },
        {
          name: "Daily Statement",
          path: "dailystatement",
          enable: true
        },

        {
          name: "Daily User Report",
          path: "dailyuserreport",
          enable: true
        },
        {
          name: "Complaint",
          path: "complaint",
          enable: true
        },
        {
          name: "Commission Earnings",
          path: "commissions",
          enable: true
        },
        {
          name: "My Commission Earnings",
          path: "mycommissions",
          enable: true
        }
      ];
    }
  },
  methods: {
    opend2r() {
      let url =
        "https://play.google.com/store/apps/details?id=com.bonrixmobile.b2crechargenew";
      var win = window.open(url, "_blank");
      win.focus();
    },
    openb2c() {
      let url =
        "https://play.google.com/store/apps/details?id=com.bonrixmobile.b2crecharge";
      var win = window.open(url, "_blank");
      win.focus();
    }
  },
  watch: {
    $route(to, from) {
      this.way = to.name;
      console.log(this.way);
    },
    fsize(value) {
      this.fontsize = value;
    }
  },
  mounted() {
    let vm = this;
    vm.fontsize = vm.$props.fsize;
    vm.$store
      .dispatch("axiosget", {
        url: "HelpLine_Number",
        data: {}
      })
      .then(function(res) {
        vm.support = res.data.Message;
      });
  }
};
</script>

<style>
.whitecolor {
  color: white !important;
}
</style>
